import { trackReplyAddressesEvent } from "../analytics";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const trackLearnMoreClicked = () => trackReplyAddressesEvent("'Learn more' clicked");

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const trackAddModalOpened = () => trackReplyAddressesEvent("Add address modal opened");

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const trackEditModalOpened = (defaultAddress: boolean, replyAddressID?: string, displayName?: string) =>
  trackReplyAddressesEvent("Edit address modal opened", {
    defaultAddress,
    replyAddressID,
    displayName,
  });

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const trackPreviewAddressModalOpened = (email: string, displayName?: string) =>
  trackReplyAddressesEvent("Preview address modal opened", {
    email,
    displayName,
  });

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const trackDeleteAddressModalOpened = (defaultAddress: boolean, replyAddressID?: string, displayName?: string) =>
  trackReplyAddressesEvent("Delete address modal opened", {
    defaultAddress,
    replyAddressID,
    displayName,
  });

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const trackTipFollowed = () => trackReplyAddressesEvent("Reply address tip followed");

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const trackTipClosed = () => trackReplyAddressesEvent("Reply address tip closed");
